import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteIncomeInformation: Map<string, ConfirmationData> = new Map([
    ["ca518710-9d7e-4722-b0de-bdb8a0a13c79", { hidden: true }],
    ["18c1398e-8599-43f1-9c53-14b87cb26d69|4a967829-f99e-499d-bd44-91d655e894b1", { hidden: true }],
]);



